// extracted by mini-css-extract-plugin
export default {"poster":"ScIndex_poster__0BM8Q","wrap":"ScIndex_wrap__aJkIX","container":"ScIndex_container__Wf1AL","pRight":"ScIndex_pRight__fg9wo","arrowP":"ScIndex_arrowP__FK-4t"};